import React from "react";
import {  Row } from "reactstrap";
import { Droppable } from "react-beautiful-dnd";
import ElementWrapper from "../../../components/element/ElementWrapper/ElementWrapper";
import { elementConstants } from "../../../../constants/cms/form/element/element.constants";
import { containers } from "../../../models/containers";
import { securityHelper } from "../../../../helpers/securityHelper";
import { connect } from "react-redux";
import './ContainerElements.css'
import { cmsHelper } from "../../../helpers/cmsHelper";
import { sourceTypes } from "../../../../constants/cms/sourceType";

class ContainerElements extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      collapse: false,
      elements: null
    };
  }
  toggle() {
    this.setState(state => ({ collapse: !state.collapse }));
  }
  addOnClick = (draggableId) => {
    const { enviroment, listElements, source, dispatch } = this.props;
    cmsHelper.addElementByClick(enviroment, listElements, source, draggableId, dispatch)
  }

  restoreList = () => {
    const elements = Array.from(containers);
    const newElements = elements.map(el => {
      const newEl = Object.assign({}, el);
      newEl.guid = securityHelper.createGuid();
      return newEl;
    });
    this.setState({ elements: newElements });
  };

  componentDidMount() {
    if (typeof this.props.getRef === "function") {
      this.props.getRef({
        restoreList: this.restoreList
      });
    }
    this.restoreList();
  }
  render() {
    const { elements } = this.state;
    return (
      <div className="element-list-aside">
        <Droppable droppableId={"sidebar-column"}>
          {provided => (
            <div ref={provided.innerRef} style={{ overflow: "hidden" }}>
              {elements &&
                elements.map((c, index) => {
                  return (
                    <ElementWrapper
                      key={index}
                      id={`${elementConstants.CONTAINER}:${c.id}:${c.guid}`}
                      index={index}
                    >
                      <Row className='container-drop-item'>
                        {c.type.map((t, index) => {
                          return (
                            <div
                              key={index}
                              style={{
                                width: t,
                                height: "50px",
                                backgroundColor: "#fff",
                                border: "1px solid rgba(201, 201, 201, 0.49)"
                              }}
                            >
                              {this.props.enviroment !== sourceTypes.TEMPLATE ? <div className="quick-add-container"><i style={{ fontSize: "12px" }} className="fa fa-plus" onClick={() => this.addOnClick(`${elementConstants.CONTAINER}:${c.id}:${c.guid}`)} /></div> : null}
                            </div>
                          );
                        })}
                      </Row>
                    </ElementWrapper>
                  );
                })}
            </div>
          )}
        </Droppable>
      </div>
    );
  }
}
function mapStateToProps(state) {
  const { enviroment } = state.cms;
  let activeElements = null;
  let source = null;
  if (enviroment === sourceTypes.FORM) {
    activeElements = state.form.formElements;
    source = state.form;
  }
  if (enviroment === sourceTypes.PAGE) {
    activeElements = state.page.pageElements;
    source = state.page;
  }
  return {
    template: state.template,
    source,
    activeElements,
    listElements: state.element.elements,
    enviroment
  };
}

export default connect(mapStateToProps)(ContainerElements);
